import { render, staticRenderFns } from "./new9.vue?vue&type=template&id=59d25dd2&scoped=true&"
import script from "./new9.vue?vue&type=script&lang=js&"
export * from "./new9.vue?vue&type=script&lang=js&"
import style0 from "./new9.vue?vue&type=style&index=0&id=59d25dd2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d25dd2",
  null
  
)

export default component.exports